import React from 'react';

import moment from 'moment';

import { CondoStrictDatePickerComponentWithIntl } from '@share/components';
import { ROOMS_UNAVAILABLE_ERROR } from '@constants';
import { ICondoDetailsState, IMenuState, IMyProfileState } from '@share/store/slices';
import { DateSearchTypeEnum } from '@share/common-types';
import { useSelector } from 'react-redux';
import { RootState } from '@share/utils';

import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';

import './style.scss';

interface IProps {
  startDate: Date | null | undefined;
  endDate: Date | null | undefined;
  error: string;
  editDates: boolean;

  leftAlign?: boolean;

  setStartDate: (date: Date | null | undefined) => void;
  setEndDate: (date: Date | null | undefined) => void;
  setError: (error: string) => void;
  setEditDates: (editDates: boolean) => void;
}

export const HomesDatePicker: React.FC<IProps> = ({ startDate, endDate, error, editDates, setStartDate, setEndDate, setError, setEditDates, leftAlign = false }) => { 

  const loginStore = useSelector((state: RootState) => state.loginStore);

  const { unavailableDates, rates } = useSelector((state: RootState) => state.luxuryHomesDetailsStore);

  const startDateFormatted = startDate ? moment(startDate).format('yyyy-MM-DD') : undefined;
  const endDateFormatted = endDate ? moment(endDate).format('yyyy-MM-DD') : undefined;

  if (!editDates) {
    return (
      <div className="homes-date-picker">
        <div className="date-picker-header">
          <div className="date-picker-header-icon">
            <FontAwesomeIcon icon={faCalendarAlt} />
          </div>
          <div className="date-picker-header-content">
            <div className="date-picker-header-content-title">
              <FormattedMessage id="check.in" /> / <FormattedMessage id="check.out" />
            </div>
            <div className="date-picker-header-content-value">
              {startDateFormatted} - {endDateFormatted}
            </div>
          </div>
          <div className="date-picker-header-action">
            <button className="date-picker-header-action-button" onClick={() => setEditDates(true)}>Update</button>
          </div>
        </div>
      </div>
    )
  }

  const errorMessage = error === ROOMS_UNAVAILABLE_ERROR ? 'no.available.dates' : 'generic.error';
  
  return (
    <div className={`homes-date-picker ${leftAlign ? 'left-align' : ''}`}>
      <CondoStrictDatePickerComponentWithIntl
        condoDetailsStore={{} as ICondoDetailsState}
        condoStrictDatesStore={{
          startDate: startDateFormatted,
          endDate: endDateFormatted,
          key: 'selection',
          error,
          searchType: DateSearchTypeEnum.Strict,
        }}
        loginStore={loginStore}
        menuStore={{} as IMenuState}
        myProfileStore={{} as IMyProfileState}
        
        condoFlexibleDatePickerStore={undefined}
        condosStore={undefined}
        isSearch={false}
        forceStrict={true}
        skipOptimalDates={true}
        
        clearError={() => setError('')}

        disabledDates={unavailableDates?.map((date: any) => moment(date, 'YYYY-MM-DD').toDate())}
        datesRestrictions={rates?.days}

        setDates={(dates: { startDate: Date; endDate: Date; }) => {
          setStartDate(dates?.startDate);
          setEndDate(dates?.endDate);
        }}
        resetDates={() => {
          setStartDate(undefined);
          setEndDate(undefined);
        }}
        
        setSearchType={() => {}}
        setDatesExperiences={() => {}}
        setSearchTypeExperiences={() => {}}
        resetFlexibleState={() => {}} />

      {error && (
        <div className="error"><FormattedMessage id={errorMessage} /></div>)}
    </div>
  );
}; 